import {
  Autocomplete,
  Box,
  CircularProgress,
  ListItem,
  MenuItem,
} from "@mui/material";
import { memo } from "react";

import CustomInput from "./../../components/inputs/CustomInput";
import CustomDialog from "./../../components/layouts/common/CustomDialog";
import { CenteredBox } from "./../../components/layouts/OneViewBox";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import moment from "moment";
import CreatableRegionComponent from "../../components/custom/CreateableRegionComponent";
import { REGIONS_TYPE, USER_ROLES } from "../../utils/constants";
import AsyncDropDown from "../../components/inputs/AsyncDropDown";
import { getUserApi } from "../../apis/user.api";
import CreatableDropDownComponent from "../../components/custom/CreateableDropodown";
import CreateController from "../user/CreateController";
import {
  getCityApi,
  getCountryApi,
  getStateApi,
} from "../../apis/CountryStateCity.api";

const CreateUi = ({
  title,
  modalKey,
  fetchLoading,
  isUpdate,
  fields,
  setFields,
  loading,
  onSubmit,
}) => {
  const ahmedabadTalukaList = [
    { id: 1, label: "Daskroi" },
    { id: 2, label: "Sanand" },
    { id: 3, label: "Dholka" },
    { id: 4, label: "Viramgam" },
    { id: 5, label: "Detroj-Rampura" },
    { id: 6, label: "Bavla" },
    { id: 7, label: "Mandal" },
    { id: 8, label: "Barwala" },
    { id: 9, label: "Ahmedabad City" },
  ];
  return (
    <>
      <CustomDialog
        id={modalKey}
        loading={loading || fetchLoading}
        err={fields.err}
        onSubmit={onSubmit}
        title={`${isUpdate ? "Update" : "Create"} ${title}`}
        closeText="Close"
        confirmText={`${isUpdate ? "Update" : "Create"}`}
      >
        {(loading || fetchLoading) && (
          <CenteredBox>
            <CircularProgress />
          </CenteredBox>
        )}
        {!fetchLoading && (
          <>
            <CustomInput
              autoFocus={true}
              disabled={loading}
              value={fields.name}
              onChange={(e) =>
                setFields({ ...fields, err: "", name: e.target.value })
              }
              type="text"
              label={"Camp Name*"}
            />

            {/* <CustomInput
              disabled={loading}
              value={fields.camp_category}
              onChange={(e) =>
                setFields({ ...fields, err: "", camp_category: e.target.value })
              }
              type="text"
              label={"Camp Category*"}
            /> */}

            {/* <CustomInput
              disabled={loading}
              value={fields.total_expected_person}
              onChange={(e) =>
                setFields({
                  ...fields,
                  err: "",
                  total_expected_person: e.target.value,
                })
              }
              type="number"
              label={"Total Expected Person*"}
            /> */}

            <DesktopDatePicker
              value={moment(fields.start_date)}
              inputFormat="DD/MM/YYYY"
              onChange={(val) => {
                setFields({
                  ...fields,
                  err: "",
                  start_date: val?.toISOString(),
                });
              }}
              label="Select Camp Date*"
              renderInput={(params) => (
                <CustomInput placeholder="Select Camp Date*" {...params} />
              )}
            />

            <AsyncDropDown
              Value={
                fields?.camp_head
                  ? {
                      _id: fields?.camp_head._id || fields?.camp_head,
                      name: fields?.camp_head.name || fields?.camp_head_name,
                    }
                  : null
              }
              lazyFun={async (para) => {
                return await getUserApi({ ...para, team: true });
              }}
              OptionComponent={({ option, ...rest }) => {
                return (
                  <MenuItem {...rest} sx={{ textTransform: "capitalize" }}>
                    {option.name}
                  </MenuItem>
                );
              }}
              onChange={async (changedVal) => {
                setFields({
                  ...fields,
                  camp_head: changedVal ? changedVal._id : null,
                  camp_head_name: changedVal ? changedVal.name : null,
                });
              }}
              titleKey={"name"}
              valueKey={"_id"}
              InputComponent={(params) => (
                <CustomInput placeholder={"Camp Coordinator*"} {...params} />
              )}
            />
            {/* <CustomInput
              multiline
              rows={2}
              disabled={loading}
              value={fields.address_line}
              onChange={(e) =>
                setFields({ ...fields, err: "", address_line: e.target.value })
              }
              type="text"
              label={"Camp Address*"}
            /> */}
            {/* <AsyncDropDown

                        defaultVal={fields.camp_coordinator}
                        lazyFun={async (para) => { return await getUserApi({ ...para, role: USER_ROLES.CAMP_COORDINATOR }) }}

                        OptionComponent={({ option, ...rest }) => {
                            return <MenuItem {...rest} sx={{ textTransform: "capitalize" }} >{option.name}</MenuItem>
                        }}
                        onChange={async (changedVal) => {
                            setFields({ ...fields, camp_coordinator: changedVal ? changedVal._id : null, })
                        }}
                        titleKey={'name'}
                        valueKey={"_id"}
                        InputComponent={(params) => <CustomInput placeholder={"Camp Coordinator*"} {...params} />}
                    /> */}
            {/* <CreatableDropDownComponent

                        createComponent={<CreateController role={USER_ROLES.CAMP_COORDINATOR} callBack={()=>{
                            
                        }} />}
                        modalKey='users'
                        disabled={loading}
                        value={typeof fields.camp_coordinator == "object" ? fields.camp_coordinator : null}
                        label={"Camp Coordinator*"}
                        getApi={async (para) => { return await getUserApi({ ...para, role: USER_ROLES.CAMP_COORDINATOR }) }}
                        onChange={async (changedVal) => {

                            setFields({ ...fields, camp_coordinator: changedVal ? changedVal._id : null, })
                        }}
                    /> */}
            <CustomInput
              disabled={loading}
              value={fields.venue}
              onChange={(e) =>
                setFields({ ...fields, err: "", venue: e.target.value })
              }
              type="text"
              multiline
              label={"Venue*"}
            />

            {/* <CreatableRegionComponent
              disabled={loading}
              value={typeof fields.country == "object" ? fields.country : null}
              label={"Select Country*"}
              type={REGIONS_TYPE.COUNTRY}
              parent={null}
              onChange={async (changedVal) => {
                setFields({
                  ...fields,
                  country: changedVal ? changedVal._id : null,
                  state: null,
                  district: null,
                  taluka: null,
                });
              }}
            /> */}

            <Box mt={2}>
              <AsyncDropDown
                // key={fields.district}
                // disabled={!}
                Value={
                  fields?.country ? { _id: 1, name: fields?.country } : null
                }
                lazyFun={async (para) =>
                  await getCountryApi({
                    ...para,
                    allStatus: true,
                    isName: true,
                  })
                }
                OptionComponent={({ option, ...rest }) => {
                  return <ListItem {...rest}>{option.name}</ListItem>;
                }}
                onChange={async (changedVal) => {
                  setFields((prev) => ({
                    ...prev,
                    // state: changedVal?._id || "",
                    country: changedVal?.name || "",
                    taluka: "",
                    state: "",
                    district: "",
                    // cityName: "",
                  }));
                }}
                titleKey={"name"}
                valueKey={"_id"}
                InputComponent={(params) => (
                  <CustomInput
                    placeholder={"Select Country*"}
                    label={"Country*"}
                    {...params}
                    margin="none"
                  />
                )}
              />
            </Box>

            {/* <CreatableRegionComponent
              disabled={loading || !fields.country || fields.country == null}
              value={typeof fields.state == "object" ? fields.state : null}
              type={REGIONS_TYPE.STATE}
              onChange={async (changedVal) => {
                setFields({
                  ...fields,
                  state: changedVal ? changedVal._id : null,
                  district: null,
                  taluka: null,
                });
              }}
              parent={
                fields.country && typeof fields.country == "object"
                  ? fields.country["_id"]
                  : fields.country
              }
              label={"Select State*"}
            /> */}

            <Box mt={2}>
              <AsyncDropDown
                key={fields.state}
                disabled={!fields?.country}
                Value={fields?.state ? { _id: 1, name: fields?.state } : null}
                lazyFun={async (para) =>
                  await getStateApi({
                    ...para,
                    allStatus: true,
                    country: fields?.country,
                    isName: true,
                  })
                }
                OptionComponent={({ option, ...rest }) => {
                  return <ListItem {...rest}>{option.name}</ListItem>;
                }}
                onChange={async (changedVal) => {
                  setFields((prev) => ({
                    ...prev,
                    state: changedVal?.name || "",
                    district: "",
                  }));
                }}
                titleKey={"name"}
                valueKey={"_id"}
                InputComponent={(params) => (
                  <CustomInput
                    placeholder={"Select State*"}
                    label={"State*"}
                    {...params}
                    margin="none"
                  />
                )}
              />
            </Box>

            {/* <CreatableRegionComponent
              disabled={loading || !fields.state || fields.state == null}
              value={
                typeof fields.district == "object" ? fields.district : null
              }
              type={REGIONS_TYPE.DISTRICT}
              onChange={async (changedVal) => {
                setFields({
                  ...fields,
                  district: changedVal ? changedVal._id : null,
                  taluka: null,
                });
              }}
              label={"Select District*"}
              parent={
                fields.state && typeof fields.state == "object"
                  ? fields.state["_id"]
                  : fields.state
              }
            /> */}

            <Box mt={2}>
              <AsyncDropDown
                key={fields.state}
                disabled={!fields.state}
                Value={
                  fields?.district ? { _id: 3, name: fields?.district } : null
                }
                lazyFun={async (para) =>
                  await getCityApi({
                    ...para,
                    allStatus: true,
                    state: fields.state,
                    isName: true,
                  })
                }
                OptionComponent={({ option, ...rest }) => {
                  return <ListItem {...rest}>{option.name}</ListItem>;
                }}
                onChange={async (changedVal) => {
                  setFields((prev) => ({
                    ...prev,
                    district: changedVal?.name || "",
                  }));
                }}
                titleKey={"name"}
                valueKey={"_id"}
                InputComponent={(params) => (
                  <CustomInput
                    placeholder={"Select District*"}
                    label={"District*"}
                    {...params}
                    margin="none"
                  />
                )}
              />
            </Box>

            <Box>
              {/* <CreatableRegionComponent
                disabled={loading || !fields.district || fields.district == null}
                value={typeof fields.taluka == "object" ? fields.taluka : null}
                type={REGIONS_TYPE.TALUKA}
                onChange={async (changedVal) => {
                  setFields({
                    ...fields,
                    taluka: changedVal ? changedVal._id : null,
                  });
                }}
                label={"Select Taluka*"}
                parent={
                  fields.district && typeof fields.district == "object"
                    ? fields.district["_id"]
                    : fields.district
                }
              /> */}
              {/* <CustomInput
                disabled={loading}
                value={fields.taluka}
                onChange={(e) =>
                  setFields({ ...fields, err: "", taluka: e.target.value })
                }
                type="text"
                label={"Taluka"}
              /> */}
            </Box>
          </>
        )}
      </CustomDialog>
    </>
  );
};
export default memo(CreateUi);
